<mat-sidenav-container fixedInViewport="true" >
    <mat-sidenav class="!border-r-[#505A78]" mode="side" opened autosize>
        <app-side-nav></app-side-nav>
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
